export default "__VITE_ASSET__CZseVAxx__"